var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyscreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 271,
    viewBox: "0 0 270 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.189 163.141V218.969C230.189 238.235 217.45 253.854 201.736 253.854H188.903H158.757H65.45C49.7361 253.854 37 238.235 37 218.969V144.508C37 125.242 49.7361 109.627 65.45 109.627H171.655C171.655 109.627 213.215 105.329 221.318 116.996C234.964 136.647 230.191 163.144 230.191 163.144L230.189 163.141Z",
    fill: "url(#paint0_linear_1496_22260)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 86.999C143.428 86.999 152.469 90.7441 159.136 97.4105C165.802 104.077 169.547 113.118 169.547 122.546C169.547 131.974 165.802 141.015 159.136 147.682C152.469 154.348 143.428 158.093 134 158.093C124.573 158.093 115.531 154.348 108.865 147.682C102.198 141.015 98.4532 131.974 98.4532 122.546C98.4532 113.118 102.198 104.077 108.865 97.4105C115.531 90.7441 124.573 86.999 134 86.999ZM134 229.187C134 229.187 205.094 229.187 205.094 211.413C205.094 190.085 170.436 166.98 134 166.98C97.5646 166.98 62.9062 190.085 62.9062 211.413C62.9062 229.187 134 229.187 134 229.187Z",
    fill: "#003149",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134 86.999C143.428 86.999 152.469 90.7441 159.136 97.4105C165.802 104.077 169.547 113.118 169.547 122.546C169.547 131.974 165.802 141.015 159.136 147.682C152.469 154.348 143.428 158.093 134 158.093C124.573 158.093 115.531 154.348 108.865 147.682C102.198 141.015 98.4532 131.974 98.4532 122.546C98.4532 113.118 102.198 104.077 108.865 97.4105C115.531 90.7441 124.573 86.999 134 86.999ZM134 229.187C134 229.187 205.094 229.187 205.094 211.413C205.094 190.085 170.436 166.98 134 166.98C97.5646 166.98 62.9062 190.085 62.9062 211.413C62.9062 229.187 134 229.187 134 229.187Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134 86.999C143.428 86.999 152.469 90.7441 159.136 97.4105C165.802 104.077 169.547 113.118 169.547 122.546C169.547 131.974 165.802 141.015 159.136 147.682C152.469 154.348 143.428 158.093 134 158.093C124.573 158.093 115.531 154.348 108.865 147.682C102.198 141.015 98.4532 131.974 98.4532 122.546C98.4532 113.118 102.198 104.077 108.865 97.4105C115.531 90.7441 124.573 86.999 134 86.999ZM134 229.187C134 229.187 205.094 229.187 205.094 211.413C205.094 190.085 170.436 166.98 134 166.98C97.5646 166.98 62.9062 190.085 62.9062 211.413C62.9062 229.187 134 229.187 134 229.187Z",
    fill: "url(#paint1_linear_1496_22260)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.062 87.4208H62.9443C62.4961 87.4208 62.1343 87.059 62.1343 86.6108C62.1343 86.1626 62.4961 85.8008 62.9443 85.8008H107.062C107.511 85.8008 107.872 86.1626 107.872 86.6108C107.872 87.059 107.511 87.4208 107.062 87.4208ZM133.08 87.4208H115.775C115.327 87.4208 114.965 87.059 114.965 86.6108C114.965 86.1626 115.327 85.8008 115.775 85.8008H133.08C133.528 85.8008 133.89 86.1626 133.89 86.6108C133.89 87.059 133.528 87.4208 133.08 87.4208ZM195.655 175.26H62.9443C62.4961 175.26 62.1343 174.898 62.1343 174.45C62.1343 174.002 62.4961 173.64 62.9443 173.64H195.655C196.103 173.64 196.465 174.002 196.465 174.45C196.465 174.898 196.103 175.26 195.655 175.26Z",
    fill: "#73B4F7"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.077 54.8912C152.522 54.8912 154.505 52.9087 154.505 50.4632C154.505 48.0176 152.522 46.0352 150.077 46.0352C147.631 46.0352 145.649 48.0176 145.649 50.4632C145.649 52.9087 147.631 54.8912 150.077 54.8912Z",
    fill: "url(#paint2_linear_1496_22260)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.351 61.2088C120.8 61.2088 121.975 60.0338 121.975 58.5844C121.975 57.1349 120.8 55.96 119.351 55.96C117.902 55.96 116.727 57.1349 116.727 58.5844C116.727 60.0338 117.902 61.2088 119.351 61.2088Z",
    fill: "url(#paint3_linear_1496_22260)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.684 215.687C220.593 215.687 224.573 211.707 224.573 206.799C224.573 201.89 220.593 197.91 215.684 197.91C210.775 197.91 206.796 201.89 206.796 206.799C206.796 211.707 210.775 215.687 215.684 215.687Z",
    fill: "url(#paint4_linear_1496_22260)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.358 227.063C140.231 227.063 141.75 225.544 141.75 223.671C141.75 221.799 140.231 220.28 138.358 220.28C136.486 220.28 134.967 221.799 134.967 223.671C134.967 225.544 136.486 227.063 138.358 227.063Z",
    fill: "url(#paint5_linear_1496_22260)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9731 86.6102C31.1069 86.6102 32.8368 84.8804 32.8368 82.7465C32.8368 80.6127 31.1069 78.8828 28.9731 78.8828C26.8392 78.8828 25.1094 80.6127 25.1094 82.7465C25.1094 84.8804 26.8392 86.6102 28.9731 86.6102Z",
    fill: "url(#paint6_linear_1496_22260)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M241.601 132.918C244.428 132.918 246.72 130.626 246.72 127.799C246.72 124.972 244.428 122.68 241.601 122.68C238.774 122.68 236.482 124.972 236.482 127.799C236.482 130.626 238.774 132.918 241.601 132.918Z",
    fill: "url(#paint7_linear_1496_22260)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M238.831 197.91C245.71 197.91 251.286 192.334 251.286 185.455C251.286 178.576 245.71 173 238.831 173C231.952 173 226.376 178.576 226.376 185.455C226.376 192.334 231.952 197.91 238.831 197.91Z",
    fill: "url(#paint8_linear_1496_22260)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.878 127.928C228.279 128.44 227.665 128.927 227.043 129.391C211.999 140.619 190.61 138.376 178.266 123.877C169.576 113.671 167.586 100.009 171.876 88.2531C173.93 82.6224 177.427 77.4302 182.316 73.2652C197.414 60.4083 220.071 62.2206 232.931 77.3155C245.783 92.413 243.975 115.068 228.878 127.928Z",
    fill: "url(#paint9_linear_1496_22260)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.437 111.576L216.577 114.434C215.623 115.387 214.079 115.387 213.128 114.434L205.598 106.904L198.066 114.434C197.118 115.387 195.571 115.387 194.617 114.434L191.757 111.576C190.802 110.62 190.802 109.076 191.757 108.125L199.287 100.598L191.757 93.0656C190.804 92.1149 190.802 90.5702 191.757 89.6169L194.617 86.757C195.571 85.8037 197.115 85.8037 198.066 86.757L205.598 94.2891L213.128 86.757C214.079 85.8037 215.623 85.8037 216.577 86.757L219.437 89.6169C220.392 90.5728 220.39 92.1149 219.437 93.0656L211.907 100.598L219.437 108.125C220.392 109.076 220.392 110.62 219.437 111.576Z",
    fill: "url(#paint10_linear_1496_22260)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1496_22260",
    x1: 133.06,
    y1: 189.357,
    x2: 152.633,
    y2: 271.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C8FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C8FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1496_22260",
    x1: 89.8863,
    y1: 208.483,
    x2: 123.693,
    y2: 152.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B4F7",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B4F7",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1496_22260",
    x1: 147.723,
    y1: 41.915,
    x2: 211.694,
    y2: 274.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C8FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C8FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1496_22260",
    x1: 117.086,
    y1: 50.3548,
    x2: 181.057,
    y2: 282.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C8FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C8FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1496_22260",
    x1: 168.661,
    y1: 36.1449,
    x2: 232.635,
    y2: 268.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B4F7",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B4F7",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1496_22260",
    x1: 92.4746,
    y1: 57.138,
    x2: 156.446,
    y2: 289.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B4F7",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B4F7",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1496_22260",
    x1: 26.8941,
    y1: 75.2054,
    x2: 90.8679,
    y2: 307.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B4F7",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B4F7",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1496_22260",
    x1: 212.984,
    y1: 23.9324,
    x2: 276.955,
    y2: 256.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B4F7",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B4F7",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1496_22260",
    x1: 238.831,
    y1: 163.194,
    x2: 238.831,
    y2: 196.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B4F7",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B4F7",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1496_22260",
    x1: 211.751,
    y1: 87.3431,
    x2: 191.446,
    y2: 131.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899DB3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#899DB3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1496_22260",
    x1: 205.598,
    y1: 87.4375,
    x2: 205.598,
    y2: 124.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575656",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575656"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyscreen);
export default __webpack_public_path__ + "static/media/emptyscreen.d712c895fbd8d90a20d1f4745a2ccabc.svg";
export { ForwardRef as ReactComponent };